import { render, staticRenderFns } from "./VendorModal.vue?vue&type=template&id=63653796&scoped=true"
import script from "./VendorModal.vue?vue&type=script&lang=js"
export * from "./VendorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63653796",
  null
  
)

export default component.exports